import { Typography } from "@mui/material"
import { FC } from 'react'
import { MainContainer } from "../../components/MainContainerComp"
import { SlipsTable } from "../../components/SlipsTable"
import { IBoardSlipsSummaryData } from "./BoardSlipsData"
import { BoardsTitle } from "./BoardSlipsModels"
import { headerStyle } from "./styled"

interface IBoardSlipsProps {
  data: IBoardSlipsSummaryData;
  board: keyof typeof BoardsTitle;
}

export const BoardSlips: FC<IBoardSlipsProps> = ({ data, board }) => {
  return (
    <MainContainer hasGreyBg>
      <Typography className='main-title' sx={headerStyle}>
        {BoardsTitle[board]} Slips
      </Typography>
      <Typography
        component={'div'} 
        variant='container' 
        data-automation="data-container"
      >
        {
          data.shifts.map((shift, i) => (
            <SlipsTable shift={shift} key={i} />
          ))
        }
      </Typography>
    </MainContainer>
  )
}